module.exports = __webpack_public_path__ + "img/Footer-background.d4b3dd9a.webp";